import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output
} from '@angular/core';

@Component({
	selector: 'breadcrumb-item-view',
	templateUrl: './breadcrumb-item-view.component.html',
	styleUrls: ['./breadcrumb-item-view.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})

export class BreadCrumbItemViewComponent {
	@Input() public tooltip?: string;
	@Input() public showBreadCrumbButton = true;
	@Input() public isActive = false;
	@Output() public action: EventEmitter<any> = new EventEmitter();

	constructor () {}
}
